import { breakpointEventService } from './services/breakpointEventService.js';
import { conf, setConfig } from './services/configService.js';
import { dataLayerClickService } from './services/dataLayerClickService.js';
import { effectService } from './services/effectService.js';
import { googleTagManagerService } from './services/googleTagManagerService.js';
import { addScript } from './utils/domUtils.js';
import { isDrupalSessionActive } from './utils/drupalUtils.js';

const conditionallyInitOneTrustService = () => {
  if (conf.activate_cmp && conf.cmp_js_url) {
    import('./services/oneTrustService.js').then(({ oneTrustService }) =>
      oneTrustService.init()
    );
  } else {
    window.dispatchEvent(new Event('CmpReady'));
    window.natgeo.events.CmpReady = true;
  }
};

const conditionallyInitLinkProxyService = () => {
  if (conf.siteCountryCode === 'fr') {
    import('./services/linkProxyService.js').then(({ linkProxyService }) =>
      linkProxyService.init()
    );
  }
};

const conditionallyInitDrupalEditService = () => {
  const h = window.location.hostname;
  if (
    (h.includes('cms-') || h.includes('ngeo.local-')) &&
    isDrupalSessionActive()
  ) {
    import('./services/drupalEditService.js').then(({ drupalEditService }) =>
      drupalEditService.init()
    );
  }
};

const setupRawConfig = async () => {
  const rawConfigUrl = `/config/raw-config.json?${window.natgeo.config.hash}`;
  const rawConfigString = await fetch(rawConfigUrl).then(res => res.text());
  // Save in window, so React hydration can use it later.
  window.natgeo.config.string = rawConfigString;
  setConfig(rawConfigString);
};

let reactHydrated = false;
export const hydrateReact = () => {
  if (!reactHydrated) {
    reactHydrated = true;
    window.hydration.forEach(src => addScript(src));
  }
};

let vanillaHydrated = false;
const hydrateVanilla = () => {
  if (!vanillaHydrated) {
    vanillaHydrated = true;

    // oxlint-disable-next-line no-console
    console.time('Vanilla Hydration');
    setupRawConfig().then(() => {
      breakpointEventService.init();
      effectService.init();
      googleTagManagerService.init();
      dataLayerClickService.init();

      conditionallyInitOneTrustService();
      conditionallyInitLinkProxyService();
      conditionallyInitDrupalEditService();

      if (conf.bundle_code_custom_js) {
        try {
          // oxlint-disable-next-line no-eval
          eval(conf.bundle_code_custom_js);
        } catch (error) {
          // oxlint-disable-next-line no-console
          console.log('Error on bundle_code_custom_js:', error);
        }
      }

      // oxlint-disable-next-line no-console
      console.timeEnd('Vanilla Hydration');
    });
  }
};

const vanillaBundles = [
  'homepage',
  'page',
  'show',
  'subscribe_page',
  'author',
  'photographer',
  'vertical_slideshow_gallery',
  'photo_gallery',
  'hub_page',
  'error_404',
  'search',
  'pod_index'
];
if (
  window.natgeo.isDev ||
  !vanillaBundles.includes(window.natgeo.bundle) ||
  document.querySelector('[data-needs-hydration]')
) {
  hydrateReact();
  window.addEventListener('ReactHydration', hydrateVanilla);
} else {
  hydrateVanilla();
}

window.hydrateReact = hydrateReact;
window.hydrateVanilla = hydrateVanilla;
